import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  createCategoriesServer,
  getCategoriesServer,
  updateCategoriesServer,
} from "../../../apis/categoriesApi";
import { categoriesScheme } from "../../../lib/validations/CategoriesValidation";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function AddCategory() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [addCategoryInitial, setAddCategoryInitial] = useState({
    name: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      editCategory(id);
    }
  }, [id]);

  const editCategory = async (id) => {
    setEditLoader(true);
    try {
      const res = await getCategoriesServer(id);
      if (res.result) {
        setAddCategoryInitial({
          name: res.result.name,
        });
      }
    } catch (error) {
      console.error("Error fetching Category:", error);
    } finally {
      setEditLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: addCategoryInitial,
    enableReinitialize: true,
    validationSchema: categoriesScheme,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let res;
        if (id) {
          values.id = id;
          res = await updateCategoriesServer(id, values);
          console.log(res);
        } else {
          res = await createCategoriesServer(values);
        }
        setLoading(false);
        formik.resetForm();
        navigate("/category");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/category");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  <TextInputFormik label="Name" field="name" formik={formik} />

                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
